import { useRef } from "react";
import { Typography, type TypographyProps } from "@mui/material";
import { packsizeHooks } from "@packsize/utils";

interface ClipboardTypographyProps extends TypographyProps {
	onSuccess?: () => void;
	onError?: (error: unknown) => void;
}

export const ClipboardTypography: React.FC<ClipboardTypographyProps> = ({
	children,
	sx,
	onSuccess,
	onError,
	...props
}) => {
	const copyToClipboard = packsizeHooks.useCopyToClipboard(onSuccess, onError);
	const typographyRef = useRef<HTMLSpanElement>(null);

	const handleClick = () => {
		const textContent = typographyRef.current?.textContent ?? "";

		if (textContent !== "") {
			copyToClipboard(textContent);
		}
	};

	return (
		<Typography
			{...props}
			ref={typographyRef}
			onClick={handleClick}
			sx={{
				cursor: "pointer",
				"&:hover": {
					textDecoration: "underline",
				},
				...sx,
			}}
		>
			{children}
		</Typography>
	);
};
